import axios from "axios";
import {
    ORG_SIMPLE_REQUEST,
    ORG_SIMPLE_SUCCESS,
    ORG_SIMPLE_FAIL,
    ORG_SIMPLE_CLEAR_ERRORS
} from "../Constants/org_hierarchy_constants";

export const get_simple_org_data = () => async (dispatch) => {
  try {
    dispatch({
      type: ORG_SIMPLE_REQUEST,
    });
    const org_hierarchy = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/get-org-hirearchy-simple-data/`
    );
    dispatch({
      type: ORG_SIMPLE_SUCCESS,
      payload: org_hierarchy,
    });
  } catch (error) {
    dispatch({
      type: ORG_SIMPLE_FAIL,
      payload: error.response,
    });
  }
};

export const org_simple_data_clearErrors = () => async (dispatch) => {
  dispatch({
    type: ORG_SIMPLE_CLEAR_ERRORS,
  });
};
